import request from '@/utils/request'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *
 */
// 例如(post)：
//  export function updateBook(obj) {
//    return request({
//      url: '/book/update',      // url = base url + request url
//      method: 'get',
//      params: obj,    //----------------->>>区别
//    })
//  }

 export function getLoginPageInfo(obj) {
   return request({
     url: '/course/getLoginPageInfo/' + obj.merchantId,      // url = base url + request url
     method: 'post',
     data: obj,    //----------------->>>区别
   })
}

export function registerStudent(obj) {
  return request({
    url: '/course/registerStudent/' + obj.merchantId,      // url = base url + request url
    method: 'post',
    data: obj,   
  })
}

export function getIdentifyCode(obj) {
  return request({
    url: '/course/getIdentifyCode',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function sendMsgCode(obj) {
  return request({
    url: '/course/sendMsgCode/' + obj.merchantId,      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}


export function loginByCode(obj) {
  return request({
    url: '/course/loginByCode/' + obj.merchantId,      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}


export function login(obj) {
  return request({
    url: '/course/login/' + obj.merchantId,      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getHomePageInfo(obj) {
  return request({
    url: '/course/getHomePageInfo/' + obj.merchantId,      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}


export function listCategory(obj) {
  return request({
    url: '/course/listCategory/' + obj.merchantId,      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function listTeachingGather(obj) {
  return request({
    url: '/course/listTeachingGather/' + obj.merchantId,      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getLoginInfo(obj) {
  return request({
    url: '/course/getLoginInfo',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function logout(obj) {
  return request({
    url: '/course/logout',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function updateStudent(obj) {
  return request({
    url: '/course/updateStudentInfo',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function updateStudentPhone(obj) {
  return request({
    url: '/course/updateStudentPhone',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getTeachingGatherDetails(obj) {
  return request({
    url: '/course/getTeachingGatherDetails',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function listOrder(obj) {
  return request({
    url: '/course/listOrder',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function listPurchasedTeachingGather(obj) {
  return request({
    url: '/course/listPurchasedTeachingGather',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getWeChatAutograph(obj) {
  return request({
    url: '/course/getWeChatAutograph/' + obj.merchantId,      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function listCashbackOrder(obj) {
  return request({
    url: '/course/listCashbackOrder',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getTeaching(obj) {
  return request({
    url: '/course/getTeaching',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function updateTeachingLearning(obj) {
  return request({
    url: '/course/updateTeachingLearning',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function unionwxpay(obj) {
  return request({
    url: '/course/unionwxpay',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}


export function unionwxpayIn(obj) {
  return request({
    url: '/course/unionwxpayIn',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getAlipayEntry(obj) {
  return request({
    url: '/course/getAlipayEntry',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getExamDetails(obj) {
  return request({
    url: '/course/getExamDetails',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function listExamItem(obj) {
  return request({
    url: '/course/listExamItem',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function submitExamResult(obj) {
  return request({
    url: '/course/submitExamResult',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function updateStudentRealName(obj) {
  return request({
    url: '/course/updateStudentBankInfo',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getStudentBankInfo(obj) {
  return request({
    url: '/course/getApplyDrawRecordInfo',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function getRealityTotal(obj) {
  return request({
    url: '/course/getRealityTotal',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}

export function addStudentDrawRecord(obj) {
  return request({
    url: '/course/addStudentDrawRecord',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}


export function listStudentDrawRecord(obj) {
  return request({
    url: '/course/listStudentDrawRecord',      // url = base url + request url
    method: 'post',
    data: obj,    //----------------->>>区别
  })
}



